<template>
<v-sheet class="pt-15 fill-height" color="primary" dark>
    <v-card color="primary" dark flat tile class="fill-height mx-auto">
        <v-card color="transparent" class="fill-height pa-5 px-10" v-if="host">
          <v-row class="fill-height" align="center" justify="center">
            <v-avatar :size="150" class="bordered" v-if="host.animation">
                  <v-img :src="'..' + host.animation"></v-img>
              </v-avatar>
            <v-img v-else
                  :src="require('../assets/onboarding1.png')"
                  contain
                  height="40vh"
                />
            <v-row align="center" justify="center">
              
                <v-card-title class="text-h4 text-center font-weight-thin" justify="center" style="word-break: keep-all">Bedankt!</v-card-title>
              <v-card-text align="center" class="text-h6 font-weight-light">We gaan voor je aan de slag.<br>Sluit deze pagina om verder te gaan.<br><br>
                -- {{host.name}} --
                
              </v-card-text>
            </v-row>
          </v-row>
        </v-card>
    </v-card>
  </v-sheet>
</template>

<script>
export default {
 data () {
    return {
      loading: true,
      host : {}
    }
    },
  computed: {
  
  },
  mounted() {
     this.load()
   
  },
  methods: {
     async load(search) {
      let response = await this.$http.post('/api/host/info' , {index: 'organisation/' + this.$route.params.index})
      this.host = response.data
      this.loading = false
    }
  }
}
</script>

<style>
.bordered .v-responsive__content {
  border: 5px solid white;
}
</style>